export const selectUser = (state) => state.auth.authResponseMessage;
